import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { constant } from '@login/resources/constant';
import { ResetPasswordService } from '@login/services/reset-password.service';
import { ApiConstants } from '@login/util/api-constants';

import { AlertService } from '@shared/services/alert.service';
import { HarpValidators } from '@shared/utils/validators';
import { InputConfig } from '@shared/models/input-config.model';
import { INPUT_CONFIGS, REGEX, TEXT_CONSTANTS } from '@shared/constants';
import { SpinnerService } from '@shared/services/spinner.service';

@Component({
  selector: 'app-forgot-account-info',
  templateUrl: './forgot-account-info.component.html',
  styleUrls: ['./forgot-account-info.component.scss'],
})
export class ForgotAccountInfoComponent implements OnInit {
  email: string;
  emailSent = false;
  recoveryEmail = '';
  forgotPasswordForm: UntypedFormGroup;

  forgotForm: UntypedFormGroup;
  emailInputConfig: InputConfig;

  constructor(
    private fb: UntypedFormBuilder,
    private resetPasswordService: ResetPasswordService,
    private spinnerService: SpinnerService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.forgotForm = this.fb.group({
      email: [
        '',
        [
          HarpValidators.required(
            TEXT_CONSTANTS.ERROR_MESSAGE_REQUIRED('Email'),
          ),
          HarpValidators.pattern(REGEX.EMAIL_REGEX, 'Email is invalid'),
        ],
      ],
    });

    this.emailInputConfig = INPUT_CONFIGS.EMAIL({ form: this.forgotForm });
  }
  onSendEmail() {
    this.spinnerService.start('Loading...');
    const { email } = this.forgotForm.value;

    this.resetPasswordService.sendRecoveryEmail(email).subscribe(
      (res: any) => {
        this.emailSent = true;
        this.alertService.clearAlert();
        this.spinnerService.stop();
      },
      (error: any) => {
        let alertMessage;
        switch (error.error.errorCode) {
          case 'ERRPRS020':
            alertMessage = ApiConstants.ACCOUNT_LOCKED_ERROR;
            break;
          case 'ERRPRS021':
            alertMessage = ApiConstants.ACCOUNT_RECOVERY_ELIGIBILITY_ERROR;
            break;
          case 'ERRPRS003':
          case 'ERRPRS005':
          case 'ERRPRS006':
          case 'ERRHPRS032':
          case 'ERRHPRS033':
            alertMessage = error.error.statusText;
            break;
          default:
            alertMessage = constant.ON_SEND_EMAIL_CALL_FAILURE;
            break;
        }
        this.alertService.setAlert(alertMessage);
        this.spinnerService.stop();
      },
    );
  }
}
